<template>
  <li
    v-for="p in parents"
    :key="p"
    class="list-group-item d-flex justify-content-between align-items-start py-0 px-4"
  >
    <div class="ms-0 w-100 placeholder-glow">
      <span class="placeholder placeholder-lg my-2" :class="`col-6`" />
      <div v-for="c in children" :key="c" class="px-4 w-100 placeholder-glow">
        <span class="placeholder placeholder-lg my-2" :class="`col-8`" />
        <div v-for="g in grandChildren" :key="g" class="ps-4 w-100 placeholder-glow">
          <span class="placeholder placeholder-lg my-2" :class="`col-${placeholderNum(6, 12)}`" />
        </div>
      </div>
    </div>
  </li>
</template>
<script lang="ts" setup>
const {placeholderNum} = usePlaceholderNum();
const parents = ref(2);
const children = ref(3);
const grandChildren = ref(2);
</script>
